
import {throwError as observableThrowError} from 'rxjs';
import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable()
export class SharedService {


    //<editor-fold desc="Variables públicas">
    @Output() emisorEventos: EventEmitter<any>;
    //</editor-fold>

    //<editor-fold desc="Variables privadas">

    private showingThrobber: boolean = false;
    //</editor-fold>

    constructor(){
        this.emisorEventos = new EventEmitter();
    }

    public mostrarThrobber() {
        if (!this.showingThrobber) {
            this.showingThrobber = true;
            this.emisorEventos.emit({accion: 'showThrobber'});
        }
    }

    public ocultarThrobber() {
        if (this.showingThrobber) {
            this.showingThrobber = false;
            this.emisorEventos.emit({accion: 'hideThrobber'});
        }
    }

    /**
     *
     * @param {Response} res
     * @returns {*}
     */
    public extractData(res) {
      const body = res.hasOwnProperty('items') ? res.items : res;
        return body || {};
    }

    /**
     * Maneja la respuesta de error para los Observables.
     * @param {Response | any} error
     * @returns {ErrorObservable}
     */
    public handleErrorObservable(error: Response | any) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }

    // private handleError(error: any): Promise<any> {
    //     console.error('An error occurred', error); // for demo purposes only
    //     return Promise.reject(error.message || error);
    // }
}
